<template>
  <div class="text-[14px]">
    <NuxtLink class="cursor-pointer hover:underline" v-if="locale === 'uk'" @click="switchLocale('en')">ENG</NuxtLink>
    <NuxtLink class="cursor-pointer hover:underline"  v-if="locale === 'en'" @click="switchLocale('uk')">УКР</NuxtLink>
  </div>
</template>

<script setup lang="ts">
const { locale, setLocale } = useI18n();
const switchLocalePath = useSwitchLocalePath();

const switchLocale = (locale: string) => {
  setLocale(locale);
  navigateTo(switchLocalePath(locale));
}
</script>


